import React, { useEffect, useState, useCallback } from "react";
import Icon_L from "../../../assets/images/Icon_L.svg";
import styles from "./style.module.css";
import signEdit from "../../../assets/images/signEdit.svg";
import signDelete from "../../../assets/images/signDelete.svg";
import axios from "axios";
import { baseBusinessUrl } from "../../../utils/baseUrl";
import { encryptRequest } from "../../../utils/encryption";

export default function AddDirectors({
  openSignatory,
  tin,
  newDirectorAddded,
  previousNewDirectorAdded,

  allDirectors,
  setAllDirectors,
}) {
  const getAllDirectors = () => {
    axios
      .get(
        `${baseBusinessUrl}CompanyDirector/CompanyDirectorGetAllDetails?Tin=${encodeURIComponent (encryptRequest(tin) as string)}`
      )
      .then((response) => {
        setAllDirectors(response.data);
      })
      .catch((err) => {
        
      });
  };

  const handleProceed = () => {
    if(allDirectors.length > 0){
      newDirectorAddded()
    }
  }

  useEffect(() => {
    getAllDirectors();
  }, []);

  return (
    <div>
      <h4 className="card-title text-center pl-3 mt-4">Add directors</h4>
      <div className="bvn_val mb-4" id="fader">
        <img src={Icon_L} alt="" />
        <small className="text-danger ml-4 font-weight-bold">
          <b>Kindly ensure that the BVN information is up to date</b>
        </small>
      </div>
      <p className={styles.directorText}>Directors</p>

      {allDirectors.map((director) => {
        return (
          <>
            <div className={styles.addedTask}>
              <div className={styles.firstCon}>
                {/* <p className={styles.id}>{director.id}</p> */}
                <div
                  className={styles.director}
                >{`${director.firstName} ${director.secondName} ${director.lastName}`}</div>
              </div>
              <div className={styles.secondCon}>
                <img src={signEdit} alt="" />
                <img src={signDelete} alt="" />
              </div>
            </div>
            <hr />
          </>
        );
      })}

      <small className={styles.directorLink} onClick={openSignatory}>
        Click to add director
      </small>
      <hr />
      <div className="d-flex justify-content-end mt-4">
        <button
          style={{ marginRight: "10px" }}
          className="btn btn-outline-goldr-3 btn-filled-white"
          onClick={previousNewDirectorAdded}
        >
          Previous
        </button>
        {/* {businessSignatoryDetailsLoading ? (
          <div className="spinner-border text-gold" role="status">
            <span className="sr-only"></span>
          </div>
        ) : ( */}
        <button
          type="submit"
          className="btn btn-danger btn-filled-red"
          onClick={handleProceed}
        >
          Proceed
        </button>
        {/* )} */}
      </div>
    </div>
  );
}
